import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getPagePath } from '@spotahome/soyuz/client';
import './SearchBreadcrumbs.scss';

import CityCrumb from './components/CityCrumb';
import HomeCrumb from './components/HomeCrumb';
import CrumbSeparator from './components/CrumbSeparator';
import TypeCrumb from './components/TypeCrumb';
import TopologyCrumb from './components/TopologyCrumb';

const SearchBreadcrumbs = ({ cityId, propertyType, topology }) => {
  const cityHref = getPagePath('marketplace.free-search', {
    params: { locationString: cityId }
  });

  const homeHref = getPagePath('externals.landing-pages.home');

  const renderPropertyTypeCrumb = () => {
    const type = propertyType[0];
    const typeUrl = `/for-rent:${type}`;

    const typeHref = topology?.length === 1 ? `${cityHref}${typeUrl}` : null;

    const typeLabel = `breadcrumb.label.${type}_for_rent`;

    return (
      <>
        <CrumbSeparator />
        <TypeCrumb href={typeHref} translationKey={typeLabel} />
      </>
    );
  };

  const renderTopologyCrumb = () => {
    const rooms = topology[0];
    const typeLabel = `search.others.apartments-${rooms}`;

    return (
      <>
        <CrumbSeparator />
        <TopologyCrumb translationKey={typeLabel} />
      </>
    );
  };

  const singlePropertyTypeFilterSelected = propertyType?.length === 1;
  const singleTopologyFilterSelected = topology?.length === 1;
  return (
    <div
      className={classnames('search-breadcrumbs')}
      itemScope
      itemType="https://schema.org/BreadcrumbList"
    >
      <HomeCrumb href={homeHref} />
      <CrumbSeparator />
      <CityCrumb
        href={singlePropertyTypeFilterSelected ? cityHref : null}
        cityId={cityId}
      />
      {singlePropertyTypeFilterSelected && renderPropertyTypeCrumb()}
      {singlePropertyTypeFilterSelected &&
        singleTopologyFilterSelected &&
        renderTopologyCrumb()}
    </div>
  );
};

SearchBreadcrumbs.propTypes = {
  cityId: PropTypes.string.isRequired,
  propertyType: PropTypes.arrayOf(PropTypes.string).isRequired,
  topology: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default SearchBreadcrumbs;
